<div class="dl-model-toolbar" [class.dl-model-toolbar--verborgen]="dlModel.fullReadonly || dlModel.inReplay()">
    <button id="nieuwModelbtn"
            class="topmenubarbtn"
            [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('STARTNEWMODEL' | translate)"
            dlBeginnersuitleg="nieuwModelbtn"            (click)="modelbeheer.nieuwMenu()">
        <i class="fa-regular fa-file"></i>
    </button>
    <button id="loadGraphbtn"
            class="topmenubarbtn"
            [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('LOADMODEL' | translate)"
            dlBeginnersuitleg="loadGraphbtn"            (click)="modelbeheer.laadMenu(false)">
        <i class="fa-regular fa-folder"></i>
    </button>
    <button id="saveGraphbtn"
            class="topmenubarbtn"
            [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('SAVEMODEL' | translate)"
            dlBeginnersuitleg="saveGraphbtn"            (click)="modelbeheer.slaOp()">
        <i class="fa-regular fa-floppy-disk"></i>
    </button>
    <button id="copyModelbtn"
            class="topmenubarbtn"
            [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('COPYMODEL' | translate)"
            dlBeginnersuitleg="copyModelbtn"            (click)="modelbeheer.kopieer()">
        <i class="fa-regular fa-copy"></i>
    </button>
    <button id="changeNamebtn"
            class="topmenubarbtn"
            [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('MODELPROPS_WIJZIG' | translate)"
            dlBeginnersuitleg="changeNamebtn"            (click)="modelbeheer.wijzigNaam()">
        <i class="fa-solid fa-tag"></i>
    </button>
    @if (modelbeheer.magSamenwerken()) {
        <button id="samenwerkBtn"
                class="topmenubarbtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('SAMENWERKEN.TITEL' | translate)"
                dlBeginnersuitleg="samenwerkBtn"                (click)="modelbeheer.openSamenwerken()">
            <i class="dl-fa4 dl-fa4--handdruk"></i>
        </button>
    }
    @if (sessie.magMeekijken()) {
        <button id="meekijkbtn"
                class="topmenubarbtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('WATCHMODEL' | translate)"
                dlBeginnersuitleg="meekijkbtn"                (click)="modelbeheer.laadMenu(true)">
            <i class="fa-regular fa-eye"></i>
        </button>
    }
    @if (sessie.heeftDashboard1()) {
        <button id="dashboardbtn"
                class="topmenubarbtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : (('DASHBOARD.TITEL' | translate) + ' 1')"
                dlBeginnersuitleg="dashboardbtn"                (click)="openDashboardv1()">
            <i class="fa-solid fa-chart-column"></i>
        </button>
    }
    @if (sessie.heeftDashboard2()) {
        <button id="dashboardbtn2"
                class="topmenubarbtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : (('DASHBOARD.TITEL' | translate) + ' 2')"
                dlBeginnersuitleg="dashboardbtn2"                (click)="openDashboardv2()">
            <i class="fa-solid fa-chart-line"></i>
        </button>
    }
    @if (sessie.magReplay()) {
        <button id="replaymodebtn"
                class="topmenubarbtn"
                [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('REPLAY.SHOW' | translate)"
                dlBeginnersuitleg="replaymodebtn"                [disabled]="!opslag.isOpgeslagen()"
                (click)="replayService.toon()">
            <i class="fa-solid fa-angles-left"></i>
        </button>
    }
    <div class="topmenubardivider"></div>
    <button id="undobtn"
            class="topmenubarbtn"
            [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('UNDO' | translate)"
            dlBeginnersuitleg="undobtn"            [disabled]="!opslag.canUndo()"
            (click)="doeUndo()">
        <i class="fa-solid fa-arrow-rotate-left"></i>
    </button>
    <button id="redobtn"
            class="topmenubarbtn"
            [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('REDO' | translate)"
            dlBeginnersuitleg="redobtn"            [disabled]="!opslag.canRedo()"
            (click)="doeRedo()">
        <i class="fa-solid fa-arrow-rotate-right"></i>
    </button>
</div>
